import { render, staticRenderFns } from "./SelectedLocation.vue?vue&type=template&id=a195674c&"
import script from "./SelectedLocation.vue?vue&type=script&lang=ts&"
export * from "./SelectedLocation.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedLocation.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports